import { Component } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';

@Component({
  selector: 'app-confirmation-demande-resiliation-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule],
  templateUrl: './confirmation-demande-resiliation-dialog.component.html',
  styleUrl: './confirmation-demande-resiliation-dialog.component.scss',
})
export class ConfirmationDemandeResiliationDialogComponent {}
